import { useAtom, useAtomValue } from 'jotai';
import { useEffect } from 'react';

import { ThumnailType } from '../components/PdfViewer/index.types';
import { currentPageAtom } from '../store/index.atom';
import { thumbnailsAtom } from '../components/PdfViewer/Redirect/index.atom';

interface Props {
  defaultThumbnails?: ThumnailType[];
}

const useUpdateOneToOneRenderThumbnails = ({ defaultThumbnails }: Props) => {
  const [thumbnails, setThumbnails] = useAtom(thumbnailsAtom);
  const currentPage = useAtomValue(currentPageAtom);

  const updateThumbnails = (
    page: number,
    startIndex: number,
    endIndex: number,
  ) => {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    const renderThumbnails = [...thumbnails];

    for (let i = startIndex; i <= endIndex; i++) {
      renderThumbnails[page + i] = defaultThumbnails[page + i];
    }

    setThumbnails(renderThumbnails);
  };

  const updatePrevThumbnails = (page: number) => {
    if (currentPage - 1 < 0) {
      return;
    }

    updateThumbnails(page, -5, -1);
  };

  const updateNextThumbnails = (page: number) => {
    if (defaultThumbnails && currentPage + 1 > defaultThumbnails.length) {
      return;
    }

    updateThumbnails(page, 1, 8);
  };

  useEffect(() => {
    if (defaultThumbnails) {
      const thumbnails = defaultThumbnails.map(
        (_, index) =>
          ({
            page: index + 1,
            thumnail: '',
            originalWidth: 0,
            originalHeight: 0,
            hyperlink: [],
          } as ThumnailType),
      );

      thumbnails[0] = defaultThumbnails[0];
      thumbnails[1] = defaultThumbnails[1];
      thumbnails[2] = defaultThumbnails[2];

      setThumbnails(thumbnails);
    }
  }, []);

  useEffect(() => {
    if (!thumbnails || !defaultThumbnails) {
      return;
    }

    updateThumbnails(currentPage, -3, 1);
  }, [currentPage]);

  return {
    updatePrevThumbnails,
    updateNextThumbnails,
  };
};

export default useUpdateOneToOneRenderThumbnails;
